import mainRender from './worldView';

function update(scene, delta) {
  const { mainCanvas, camera } = scene;

  scene.loopDelta = delta;

  mainCanvas.reset(camera);

  const views = [];

  mainRender(scene, views, afterViewsRender.bind(scene));
}

function afterViewsRender() {
  this.entities.forEach((entity) => {
    entity.update(this);
    entity.render(this.mainCanvas);
  });
}

export default update;
